import { ClosetUnit } from "../domain";

export const layoutClosetUnit = (unit: ClosetUnit) => {
    unit.content.width = unit.width;
    unit.content.position.x = unit.leftPanel ? unit.leftPanel.thickness : 0;

    if(unit.leftPanel) {
        unit.leftPanel.depth = unit.depth;
    }

    if(unit.rightPanel) {
        unit.rightPanel.depth = unit.depth;
        unit.rightPanel.position.x = unit.content.position.x + unit.content.width;
    }
};
